module.exports = {"en":{"app.greeting":"Hello {name}, how are you today?"},"de":{"app.greeting":"Hallo {name}, wie geht's?"},"es":{"app.greeting":"Hola {name}. ¿Qué tal?"}}


//////////////////
// WEBPACK FOOTER
// ./src/react-intl/translations.json
// module id = 115
// module chunks = 0